import isEmpty from "lodash/isEmpty";
import Widget from "./base.js";
import getProfile from "tpm-lib/profile";
import { env } from "tpm-utils";

export class NewToYou extends Widget {
	constructor(props) {
		super(props);
	}

	componentWillMount() {
		this.state.page = 1;
		this.state.updatedDoess = false;
	}

	componentDidMount() {
		const profileData = this.getProfileData();
		const self = this;

		/* this getes called later ⬇️ */
		function setUp(profileData) {
			//timestamp or 24 hours ago
			const timestamp =
				profileData.new_to_you_timestamp ||
				// new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
				new Date(Date.now() - 2400000 * 60 * 60 * 1000).toISOString();

			self.getNewToYouPosts(timestamp).then((data) => {
				console.log("new to you posts", data);
				self.setState({
					timestamp,
					posts: data,
				});
			});

			self.updateNewToYouTimestamp(profileData.id);
		}

		if (typeof profileData.then === "function") {
			profileData
				.then((resp) => {
					return resp;
				})
				.then((data) => {
					setUp(data);
				});
		} else {
			setUp(profileData);
		}
	}

	getProfileData() {
		if (window.tpm_profile) return window.tpm_profile;
		const p = getProfile();
		return p;
	}

	getNewToYouPosts(afterDate, nextPage = 1) {
		return fetch(
			`https://${document.location.hostname}/wp-json/wp/v2/posts?orderby=date&order=desc&after=${afterDate}&per_page=10&page=${nextPage}`,
			{
				method: "GET",
			}
		)
			.then((response) => {
				return response.json();
			})
			.catch((error) => {
				console.log("getNewToYouPosts error", error);
			});
	}

	updateNewToYouTimestamp(userid) {
		return fetch(
			`https://accounts.${document.location.hostname}/doesspress/new-to-you?userid=${userid}`,
			{
				method: "PUT",
				credentials: "omit",
			}
		)
			.then((response) => {
				return response; /* it works, pipe that data along */
			})
			.catch((response) => {
				console.log(`new-to-you request error`, response);
			});
	}

	get userId() {
		return this.state.userId;
	}

	formatDate(dateString) {
		if (!dateString) return "";

		// Parse the date string
		const date = new Date(dateString);

		// Format the date as "MM.DD.YY | H:MM am/pm"
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		const year = String(date.getFullYear()).slice(-2);

		// Get hours for am/pm format
		let hours = date.getHours();
		const ampm = hours >= 12 ? "pm" : "am";
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'

		const minutes = String(date.getMinutes()).padStart(2, "0");

		return `${month}.${day}.${year} | ${hours}:${minutes} ${ampm}`;
	}

	nextPage() {
		if (!this.state.timestamp) return;
		const nextPage = this.state.page + 1;
		const self = this;
		this.getNewToYouPosts(this.state.timestamp, nextPage).then((data) => {
			self.setState({
				posts: data,
				page: nextPage,
			});
		});
	}

	renderContent() {
		if (!this.state.posts) return;

		if (!this.state.posts.length)
			return (
				<div>
					<p>You're all caught up, no new posts since your last visit.</p>
				</div>
			);

		return (
			<div>
				{this.state.posts.map((post) => {
					let rawContent = post.title.rendered;
					if (post.meta.paywall)
						rawContent +=
							"<img src='https://" +
							document.location.hostname +
							"/wp-content/themes/tpm25/assets/images/logo/TPMRedes_PrimeLogo_Red.svg' alt='Prime Badge' class='Archive__PrimeBadge' />";

					return (
						<div key={post.id}>
							<div class="Archive__Post">
								{post.images.thumbnail && (
									<a href={post.link} class="Archive__PostImage --thumbnail">
										<img src={post.images.thumbnail} aria-hidden="true" />
									</a>
								)}
								{post.images.medium && (
									<a href={post.link} class="Archive__PostImage --medium">
										<img src={post.images.medium} aria-hidden="true" />
									</a>
								)}
								<div class="Archive__PostInner --no-flex">
									<a
										href={post.link}
										class="Archive__PostTitle"
										dangerouslySetInnerHTML={{
											__html: rawContent,
										}}
									></a>
									<div class="Archive__Subhead">{post.meta._subhead}</div>
									<div class="Archive__Date">{this.formatDate(post.date)}</div>
								</div>
							</div>
						</div>
					);
				})}
				<div class="Archive__Pagination">
					<a
						href="#"
						class="Button --empty-black"
						onClick={this.nextPage.bind(this)}
					>
						Next Page <i className="fa fa-long-arrow-right"></i>
					</a>
				</div>
			</div>
		);
	}
}
